<template>

    <div class="inner-body-block root-sections">
        <nuxt-link v-for="item of items" :key="item.id" :to="item.link" class="element" :class="item.class"
            :style="{'background-image': item.img}"
        >
            <div class="new-flag" v-if="item.new"></div>
            <div class="overlay">
                <div class="title">{{item.name}}</div>
                <div class="additional" v-if="item.additional" :content="item.additional"></div>
            </div>
        </nuxt-link>
    </div>

</template>

<script>
export default {
    props: ['promo', 'format'],
    computed: {
        items() {
            const newItems = [];
            this.promo.forEach(el => {

                let img = '';

                if (typeof el.img === 'string') {
                    img = `/thumbs/${el.big ? 710 : 340}x320xcrop/${el.img}.${this.format}`;
                } else {

                    const prependPath = el.img.toString().substring(0, 3).padStart(3, '0');

                    img = `/_t/${prependPath}/${el.img}/catalog-banner-${el.big ? 'big' : 'small'}.${this.format}`;
                }

                newItems.push({
                    id: el.id,
                    link: el.link,
                    new: el.new,
                    name: el.name,
                    additional: el.additional,
                    class: el.big ? 'big' : '',
                    img: `url('${img}')`
                });
            });

            return newItems;
        }
    }
}
</script>